import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const TestimonialCard = ({ testimonial }) => {
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star
        key={index}
        size={18}
        className={index < rating ? 'star-filled' : 'star-empty'}
        fill={index < rating ? 'currentColor' : 'none'}
      />
    ));
  };

  return (
    <Card className="testimonial-card">
      <CardContent className="testimonial-content">
        <div className="testimonial-header">
          {testimonial.customer_image ? (
            <img 
              src={testimonial.customer_image} 
              alt={testimonial.customer_name}
              className="customer-avatar"
            />
          ) : (
            <div className="customer-avatar-placeholder">
              {testimonial.customer_name.charAt(0)}
            </div>
          )}
          <div className="customer-info">
            <h4 className="customer-name">{testimonial.customer_name}</h4>
            <div className="rating-stars">
              {renderStars(testimonial.rating)}
            </div>
          </div>
        </div>
        
        <p className="review-text">{testimonial.review_text}</p>
        
        {testimonial.product_images && testimonial.product_images.length > 0 && (
          <div className="testimonial-images">
            {testimonial.product_images.map((img, idx) => (
              <img 
                key={idx} 
                src={img} 
                alt={`Product usage ${idx + 1}`}
                className="testimonial-product-image"
              />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TestimonialCard;